import * as React from 'react'
import Links from '../Links/Links'
import TitleAndDescription from 'components/TitleAndDescription/TitleAndDescription'
import { Button } from '@conekta/frontino-ui/v2'
import { ILinks } from '../../interface'
import { MAIN_ILLUSTRATION } from '../../constants'
import { useTranslation } from 'react-i18next'

const T_ROOT = 'pages.view404'
const T_ROOT_ACTIONS = `${T_ROOT}.actions`

const Body = ({ translationsType }: ILinks): JSX.Element => {
  const { t } = useTranslation()
  const T_ROOT_TYPE = `${T_ROOT}.${translationsType}`
  const goHomeLabel = t(`${T_ROOT_ACTIONS}.goToHome`)

  return (
    <div data-testid='body' className='View404__content row'>
      <div
        className={`View404__texts
            col-xs-12 col-sm-6 col-md-7 col-lg-7
            last-xs first-sm first-md first-lg`}
      >
        <TitleAndDescription
          className='View404__title-and-description'
          description={t(`${T_ROOT_TYPE}.description`)}
          title={t(`${T_ROOT}.title`)}
        />
        <Button variant='primaryBlue' marginTop='41px' onClick={(): void => window.location.assign('/')}>
          {goHomeLabel}
        </Button>
        <Links {...{ translationsType }} />
      </div>
      <div
        className={`View404__illustration
            col-xs-12 col-sm-6 col-md-5 col-lg-5
            first-xs last-sm last-md last-lg`}
      >
        <img src={MAIN_ILLUSTRATION} alt='' />
      </div>
    </div>
  )
}

export default Body
